import { render, staticRenderFns } from "./OrderBill.vue?vue&type=template&id=5d06dd35"
import script from "./OrderBill.vue?vue&type=script&lang=js"
export * from "./OrderBill.vue?vue&type=script&lang=js"
import style0 from "./OrderBill.vue?vue&type=style&index=0&id=5d06dd35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports